import { Roles } from "@/shared/@types/Roles";
import { RoleActions } from "@/shared/@types/RoleActions";
import { isCustomerRoleIncluded } from "@/shared/helper/isCustomerRoleIncluded.helper";

const mappings = new Map<RoleActions, Array<Roles>>();

// Those that have a manager role can see all apps
mappings.set(RoleActions.PREVIEW_ALL_APPS, [
  Roles.FLEET_AT_HOME_MANAGER,
  Roles.WCC_MANAGER,
  Roles.WSC_MANAGER,
  Roles.WESTFALEN_ID_ACCOUNT_MANAGER,
]);
mappings.set(RoleActions.ACCESS_VIRTA, [Roles.VIRTA_USER]);
mappings.set(RoleActions.ACCESS_GAAS, [Roles.GAAS_USER]);
mappings.set(RoleActions.ACCESS_GAS_OCI_ONLY, [Roles.GAS_OCI_USER]);
mappings.set(RoleActions.ACCESS_DEFAULT_GAS_SHOPS, [
  Roles.GAS_STOREMAN,
  Roles.GAS_REQUESTER,
  Roles.GAS_OCI_USER,
]);
mappings.set(RoleActions.ACCESS_GLOBAL_GAS_SHOP, [Roles.GLOBAL_GAS_STOREMAN]);
mappings.set(RoleActions.ACCESS_EQUIVOLT_TCO_CALCULATOR, [
  Roles.EQUIVOLT_PRE_SALES_MANAGER,
]);
mappings.set(RoleActions.GAS_SHOP_SEE_PRICES, [
  Roles.GAS_STOREMAN,
  Roles.GAS_OCI_USER,
  Roles.GLOBAL_GAS_STOREMAN,
]);

export const checkPermissionsByRoleAction = (
  action: RoleActions,
  customerRoles: Array<Roles>,
) => {
  if (customerRoles.length === 0) return false;

  return isCustomerRoleIncluded(action, mappings, customerRoles);
};
